"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformEnquiryToRequest = void 0;
exports.transformEnquiryToRequest = function (enquiry, properties, propertiesInt, user, currentUrl, currencyId, enquireType) {
    var receiveUpdates = { receiveUpdates: enquiry.update };
    var data = {
        firstName: enquiry.firstname,
        lastName: enquiry.lastname,
        fullName: enquiry.fullname,
        email: enquiry.email,
        message: enquiry.comment,
        enquiryType: enquireType,
        userId: user.id,
        salutation: enquiry.salutation,
        phone: enquiry.phone,
        enquiryData: __assign(__assign({ budget: enquiry.budget }, receiveUpdates), { referralUrl: currentUrl, jsonData: JSON.stringify({
                Properties: properties,
                InternationalProperties: propertiesInt,
            }) }),
        currencyType: currencyId,
    };
    if (enquiry.agentId) {
        data = __assign(__assign({}, data), { enquiryData: __assign(__assign({}, data.enquiryData), { referralAgentId: enquiry.agentId }) });
    }
    return data;
};
